import React, { useCallback, useEffect, useRef } from 'react'

import { ImpressionRecorder } from '@scoir/tracking'
import PropTypes from 'prop-types'
import { v4 as uuid } from 'uuid'

import { FIELDS } from 'common/metadata-constants'
import metadataToTrackedEvent from 'common/metadata-to-tracked-event'
import { DOMAIN_TYPES, EVENT_TYPES } from 'common/track-event-constants'

import bulkTrack from './api'

const DEFAULT_DOMAIN_TYPE = DOMAIN_TYPES.IMPRESSION

const Recorder = ({ children }) => {
  const recorded = useRef([])
  const record = useCallback(() => {
    const records = recorded.current
    if (records.length > 0) {
      recorded.current = []
      bulkTrack(records)
    }
  }, [])

  useEffect(() => {
    const timerId = setInterval(record, 5000)
    return () => clearInterval(timerId)
  }, [record])

  useEffect(() => {
    const cb = () => {
      if (document.visibilityState === 'hidden') {
        record()
      }
    }
    document.addEventListener('visibilitychange', cb)
    return () => document.removeEventListener('visibilitychange', cb)
  }, [record])

  const onRecord = useCallback((metadata, type = DEFAULT_DOMAIN_TYPE) => {
    const md = {
      ...metadata,
      [FIELDS.DOMAIN_TYPE]: metadata[FIELDS.DOMAIN_TYPE] || type,
    }
    const e = metadataToTrackedEvent(md, EVENT_TYPES.IMPRESSION)
    recorded.current.push(e)
  }, [])

  return (
    <ImpressionRecorder
      onRecord={onRecord}
      msBeforeTrack={200}
      onIdentify={() => uuid()}
    >
      {children}
    </ImpressionRecorder>
  )
}

Recorder.propTypes = {
  children: PropTypes.any.isRequired,
}

export default Recorder
